export enum Constants {
    AUTHTOKEN = 'AUTHTOKEN',
    FIREBASEAUTHTOKEN = 'FIREBASEAUTHTOKEN',
}

export const STATICIMAGESBASEPATH = import.meta.env.VITE_APP_ENV === 'production'
    ? import.meta.env.VITE_APP_CDN_BASE_URL + '/assets/'
    : '/assets/';
